<template>
  <div class="index">
    <div class="main-wrap">
      <div>
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs/>
            <el-button
              type="primary"
              size="small"
              @click="departmentAdd">添 加</el-button>
            <jm-tableList
              url="/index/Plantask/index"
              :refresh.sync="refresh">
              <el-table-column
                slot="tk_name"
                label="学生">
                <template slot-scope="scope">
                  <router-link
                    :to="scope.row.tk_url"
                    v-if="scope.row.crm_id"
                    target="_blank">{{ scope.row.tk_name }}
                  </router-link>
                  <span v-else>{{ scope.row.tk_name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                slot="tk_memo"
                label="说明">
                <template slot-scope="scope">
                  <p class="memo">{{ scope.row.tk_memo }}</p>
                </template>
              </el-table-column>
              <el-table-column
                slot="lastColumn"
                label="操作"
                width="200"
                align="center">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    @click="departmentEdit(scope)"
                    size="mini">查看/编辑</el-button>
                  <el-button
                    type="danger"
                    @click="departmentDelete(scope)"
                    size="mini">删除</el-button>
                </template>
              </el-table-column>
            </jm-tableList>
            <el-dialog
              title="计划任务"
              :visible.sync="dialogFormVisible"
              v-if="dialogFormVisible"
              @close="cancel">
              <el-form
                :model="form"
                :rules="rules"
                ref="form"
                label-width="80px"
                inline>
                <el-row>
                  <el-col :span="24">
                    <el-form-item
                      label="时间："
                      prop="tk_time">
                      <el-date-picker
                        class="jm-input220"
                        v-model="form.tk_time"
                        type="datetime"
                        placeholder="选择日期时间"
                        @change="sayTime"/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item
                      label="性质："
                      prop="tk_type">
                      <el-select
                        v-model="form.tk_type"
                        placeholder="请选择"
                        :disabled="setDisabled">
                        <el-option
                          v-for="item in options.type"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key"/>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="学生："
                      prop="tk_name"
                      v-if="form.tk_type && form.tk_type < 3">
                      <el-select
                        v-model="form.tk_name"
                        filterable
                        remote
                        clearable
                        :disabled="setDisabled"
                        placeholder="学生姓名"
                        :remote-method="getStudent"
                        :loading="loading">
                        <el-option
                          v-for="item in students"
                          :key="item.crm_id"
                          :label="item.content"
                          :value="`${item.content}#${item.crm_id}`"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item
                      label="说明："
                      prop="tk_memo">
                      <el-input
                        type="textarea"
                        :rows="3"
                        placeholder="请输入内容"
                        v-model="form.tk_memo"
                        class="menu"/>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div
                slot="footer"
                class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button
                  type="primary"
                  @click="submitForm">保 存</el-button>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.menu {
  width: 500px;
}
.memo {
  overflow: hidden;
  white-space: nowrap;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
</style>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';

export default {
  data() {
    return {
      loading: false,
      refresh: false,
      disabled: false,
      dialogFormVisible: false,
      form: {
        tk_time: '',
        tk_type: '',
        tk_name: '',
        tk_memo: '',
        tk_create: '',
      },
      students: [],
      options: [],
      rules: {
        tk_time: [
          {
            type: 'date', required: true, message: '请选择时间', trigger: 'change'
          }
        ],
        tk_type: [
          {
            required: true, message: '请选择任务类型', trigger: 'change', type: 'number'
          }
        ],
        tk_name: [
          { required: true, message: '请输入学生姓名', trigger: 'change' }
        ],
        tk_memo: [
          { required: true, message: '请输入计划任务说明', trigger: 'blur' }
        ]
      }
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
  },
  computed: {
    setDisabled() {
      return !!this.form.tk_id;
    }
  },
  methods: {
    fetchData() {
      this.$http
        ._get({
          url: '/index/plantask/plantaskInterface'
        })
        .then(({ data }) => {
          this.options = data;
        });
    },
    getStudent(query) {
      if (query !== '') {
        this.loading = true;
        this.$http
          ._post({
            url: '/index/plantask/searchName',
            data: {
              tk_name: query
            }
          })
          .then(({ data }) => {
            this.loading = false;
            this.students = data;
          });
      } else {
        this.students = [];
      }
    },
    sayTime() {
      console.log(this.form);
    },
    departmentAdd() {
      this.dialogFormVisible = true;
    },
    departmentEdit({ row }) {
      this.form = Object.assign({}, row);
      this.form.tk_type = row.tk_type_key;
      this.form.tk_time = new Date(row.tk_time);
      this.dialogFormVisible = true;
    },
    departmentDelete({ row }) {
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http
          ._post({
            url: '/index/plantask/delPlan',
            data: {
              tk_id: row.tk_id
            }
          })
          .then(() => {
            this.refresh = true;
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http._post({
            url: '/index/Plantask/add',
            data: this.form,
          }).then((res) => {
            this.dialogFormVisible = false;
            if (res.result === 0) {
              this.refresh = true;
              this.form = {
                tk_id: '',
                tk_time: '',
                tk_type: '',
                tk_name: '',
                tk_memo: '',
              };
              this.$message({
                type: 'success',
                message: '创建成功!'
              });
            }
          });
        }
      });
    },
    cancel() {
      this.dialogFormVisible = false;
      this.form = {
        tk_time: '',
        tk_type: '',
        tk_name: '',
        tk_memo: '',
      };
    }
  },
  watch: {
    dialogFormVisible(val) {
      if (!val) {
        this.cancel();
      }
    }
  },
  created() {
    this.fetchData();
  }
};
</script>
